import { Component } from '@angular/core';

@Component({
    selector: 'app-downloads',
    templateUrl: './downloads.component.html',
    styleUrls: ['./downloads.component.scss'],
    standalone: false
})
export class DownloadsComponent {

  constructor(
  ) {  }

}
